
// src/web/components/group-remind-panel.jsx

import React from 'react'
import connect from '../../connects/group-remind-panel'
import {
  Card,
  CardText,
  CardActions
} from 'react-toolbox/lib/card'
import {
  Button,
  IconButton,
} from 'react-toolbox/lib/button'
import {
  List,
  ListItem,
  ListCheckbox,
} from 'react-toolbox/lib/list'
import Dropdown from 'react-toolbox/lib/dropdown'
import {
  IconMenu,
  MenuItem,
} from 'react-toolbox/lib/menu'
import Switch from 'react-toolbox/lib/switch'
import Loading from './loading.jsx'
import theme from './themes/flat-card.css'
import _ from 'lodash'

const sendAtList = _.times(24, (hour)=> ({ value: hour, label: `${hour}:00` }))
const weekDayList = [
  'send_on_sun',
  'send_on_mon',
  'send_on_tue',
  'send_on_wed',
  'send_on_thu',
  'send_on_fri',
  'send_on_sat',
  'send_on_holiday',
]

function RemindMailMenu(props) {
  const {
    t,
    isMembershipUpdating,
    group,
    member,
    updateRemindMailSetting,
  } = props
  const onChange = (value) => {
    console.log('onChnage')
  }
  return (
    <div style={{ width: 150, height: 52, right: 0, paddingTop: 15}}>
      <Switch
        checked={member.remind_mail}
        disabled={isMembershipUpdating}
        onChange={(value) => updateRemindMailSetting(props, member, value)}/>
    </div>
  )
}

class GroupRemindPanel extends React.Component {
  render() {
    const {
      t,
      ui,
      group,
      isRemindSettingUpdating,
      remindSchedule,
      updateRemindSchedule,
      cancelAllRemind,
      updateRemindMailSetting,
      isMembershipUpdating
    } = this.props
    const isNoReminder = remindSchedule && _.reduce(weekDayList, (result, item)=> result && !remindSchedule[item], true) || false
    return (
      <Card theme={theme}>
        <CardText>
          {!remindSchedule && <Loading />}

          {remindSchedule && <strong>{t('label:タイムゾーン')}</strong>}
          {remindSchedule &&
            <Dropdown auto
              value={remindSchedule.timezone}
              template={(item)=> <span>{item.label}:&nbsp;{t('timezone:' + item.label)}</span>}
              source={_.map(_.range(-12, 15), (i)=> { return { value: i, label: `UTC${i < 0 ? '-' : '+'}${Math.abs(i)}` }})}
              onChange={(value)=> updateRemindSchedule(this.props, 'timezone', value)} />
          }

          {remindSchedule &&
            <strong>{t('label:リマインド通知時刻')}</strong>
          }
          {remindSchedule &&
            <Dropdown auto
                source={sendAtList}
                value={remindSchedule.send_at}
                template={(time)=> <span>{t('label:時ごろに通知', { time: time.label })}</span>}
                onChange={(value)=> updateRemindSchedule(this.props, 'send_at', value)} />
          }
          {remindSchedule &&
            <strong>{t('label:リマインド通知日')}</strong>
          }
          {remindSchedule &&
            <List >
              <ListCheckbox disabled={isRemindSettingUpdating}
                caption={t('label:すべてのリマインド通知を送らない')}
                checked={isNoReminder}
                onChange={()=> cancelAllRemind(this.props)} />
              {_.map(weekDayList, (item)=> 
                <ListCheckbox key={item} disabled={isRemindSettingUpdating}
                    caption={t(`label:${item}`)}
                    checked={remindSchedule[item]}
                    onChange={()=> updateRemindSchedule(this.props, item, !remindSchedule[item])} />
              )}
            </List>
          }
          {remindSchedule && !isNoReminder && <strong>{t('label:個別リマインド通知')}</strong>}
          {remindSchedule && !isNoReminder && <div key="title" className={theme.labelContainer}>
              <div key="remider" className={theme.remindLabel}>{t('label:リマインド通知')}</div>
            </div>}
          {remindSchedule && !isNoReminder && 
            <List>
              {_.map(group.members, (member, i)=> 
                <ListItem key={member.user_id} selectable={false} ripple={false} index={i}
                  avatar={member.icon_image.thumb_url}
                  caption={member.name}
                  rightActions={[<RemindMailMenu key="remind_menu" t={t} group={group} member={member} 
                                  isMembershipUpdating={isMembershipUpdating} 
                                  updateRemindMailSetting={updateRemindMailSetting} />]}
                  />
               )}
            </List>
          }
        </CardText>
      </Card>
    )
  }
}

export const RawGroupRemindPanel = GroupRemindPanel
export default connect(GroupRemindPanel)



// WEBPACK FOOTER //
// ./src/web/components/group-remind-panel.jsx